import { EFormStatus, useFormContext, useFormField } from '@cian/frontend-request-form-widget';
import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';
export function useFieldError(fieldName) {
  var formContext = useFormContext();
  var _useFormField = useFormField({
      name: fieldName
    }),
    meta = _useFormField.meta;
  var _useBooleanState = useBooleanState(),
    isErrorShown = _useBooleanState.state,
    showError = _useBooleanState.setTrue,
    hideError = _useBooleanState.setFalse;
  var status = formContext.status;
  React.useEffect(function () {
    if (status === EFormStatus.QuestionSubmitted) {
      showError();
    }
  }, [status, showError]);
  var errorMessage = isErrorShown ? meta.error : '';
  return {
    showError: showError,
    hideError: hideError,
    errorMessage: errorMessage
  };
}